// extracted by mini-css-extract-plugin
module.exports = {"pageBox":"index_pageBox__lPVNv"};